import CryptoJS from "crypto-js";

export const getEncryptData = (data) => {
  // Encrypt
  const ciphertext = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    process.env.NEXT_PUBLIC_CRYPTO_SECRET
  ).toString();
  return ciphertext;
};

export const getDecryptData = (decryptText = "") => {
  if (!decryptText) return "";
  // Decrypt
  const bytes = CryptoJS.AES.decrypt(decryptText, process.env.NEXT_PUBLIC_CRYPTO_SECRET);
  const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  return decryptedData;
};
